import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';
import { PAYMENT_TRANSFER } from '../accoundDetailsUtil';
const {
  NO_INTENTION,
  MAKE_PAYMENTS,
  RECEIVE_PAYMENTS,
  MAKE_AND_RECEIVE_PAYMENTS
} = PAYMENT_TRANSFER;
const PaymentTransfer = ({ values, onChange }) => (
  <Content>
    {({
      accountDetailsPaymentTransferTitle = '',
      accountDetailsCheckBoxNoPayment = '',
      accountDetailsCheckBoxMakePayment = '',
      accountDetailsCheckBoxReceivePayment = '',
      accountDetailsCheckBoxMRPayment = '',
      accountDetailsFormError = '',
      accountDetailsPaymentTransferTitleHelpText = ''
    }) => (
      <Field
        name="accountDetailsPayment"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="accountDetailsPayment"
            title={accountDetailsPaymentTransferTitle}
            description={accountDetailsPaymentTransferTitleHelpText}
            validationMessage={touched && !!error ? accountDetailsFormError : ''}
          >
            <GenericRadio.StackedSet
              groupName="businessType-group"
              items={[
                {
                  id: NO_INTENTION,
                  labelText: accountDetailsCheckBoxNoPayment
                },
                {
                  id: MAKE_PAYMENTS,
                  labelText: accountDetailsCheckBoxMakePayment
                },
                {
                  id: RECEIVE_PAYMENTS,
                  labelText: accountDetailsCheckBoxReceivePayment
                },
                {
                  id: MAKE_AND_RECEIVE_PAYMENTS,
                  labelText: accountDetailsCheckBoxMRPayment
                }
              ]}
              selectedId={values.accountDetailsPayment}
              onChange={selectedId => {
                input.onChange(selectedId);
                onChange(selectedId);
              }}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default PaymentTransfer;
